// import $, { each } from "jquery";

import "./js/header";
import "./js/header-tools";

import "slick-carousel-latest";
import "pfkl-vtabs/vtabs/vtabs.min.js";
import "pfkl-vcollapse/vcollapse/vcollapse.min.js";
import "pfkl-vselect/vselect/vselect.min.js";

// Maps
import "./js/jvectormap/jquery-jvectormap.min.js";
import "./js/map/jquery-jvectormap-world-mill-sc"; // Map file, same as EUDiF
import "./js/home-worldmap";
import "./js/www-maps";
import "./js/region-detail-map";
import "./js/country-detail-map";
import "./js/governance-worldmap";
import "./js/project-map";

// share/embed
import "./js/social-share";
import "./js/add-to-calendar";

//marquee | Credit: https://www.jqueryscript.net/animation/jQuery-Plugin-Scrolling-Elements-Ticker.html
import "./js/ticker.js";
// Chart.js
import "./js/charts";
import "./js/indices-chart";
// Login
import "./js/login";
// Search
import "./js/search";
// Database
import "./js/database";
import "./js/database-maps-charts";
import "./js/database-tooltip";
import "./js/database-export";
import "./js/database-addanswer";
import "./js/database-delete-emb";
// Tool
import "./js/tool";

// import "./js/testlab";

jQuery(function ($) {
  // $('.ticker').ticker();

  // Check if element has entered viewport
  $.fn.isInViewport = function () {
    const element = $(this);

    if (element.length > 0) {
      const elementTop = element.offset().top;
      const viewportTop = $(window).scrollTop();
      const elementBottom = elementTop + element.outerHeight();
      const viewportBottom = viewportTop + $(window).height();

      return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    return;
  };

  console.log("Ready index");

  // General  UX ////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".ux-click-fadein").on("click", function () {
    const elm = $($(this).data("target"));
    elm.fadeIn();
  });

  $(".ux-click-fadeout").on("click", function (e) {
    if (e.target === this) {
      const elm = $($(this).data("target"));
      elm.fadeOut();
    }
  });
  // General  UX ////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Slick carousels ////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".slick-me.slick-autoplay").each(function (index) {
    const speed =
      $(this).data("speed") !== undefined ? $(this).data("speed") : 3000;
    const dots =
      $(this).data("dots") !== undefined ? $(this).data("dots") : true;

    $(this).slick({
      autoplay: true,
      autoplaySpeed: speed,
      dots: dots,
      pauseOnHover: false,
    });
  });

  function initFeaturedSeriesCarousel(elm) {
    const slidesPerPage = elm.data("slides") || 1;
    const responsive = [];

    const breakpoints = { lg: 1280, md: 1024, sm: 768, xs: 640 };
    Object.keys(breakpoints).map((screen) => {
      const slidesPerScreen = elm.data("slides-" + screen);
      if (!isNaN(parseInt(slidesPerScreen))) {
        responsive.push({
          breakpoint: breakpoints[screen],
          settings: {
            slidesToShow: slidesPerScreen,
            slidesToScroll: slidesPerScreen,
          },
        });
      }
    });

    elm.on('init', function (event, slick) {
      $(this).next().find('.page-index').text('1 of ' + slick.slideCount);
    });

    elm.slick({
      infinite: false,
      slidesToShow: slidesPerPage,
      slidesToScroll: slidesPerPage,
      autoplay: false,
      arrows: true,
      prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
      nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
      responsive,
    }).on('afterChange', function(event, slick, currentSlide) {
      let totalSlides = slick.slideCount;
      let currentSlideIndex = currentSlide + 1; // To make it 1-based

      console.log('currentSlide A', currentSlide);
      // $('.pagination .page-index').text(currentSlideIndex + ' of ' + totalSlides)
      $(this).next().find('.page-index').text(currentSlideIndex + ' of ' + totalSlides)
    });
  }

  $(".featured-series-carousel").each(function (index) {
    const elm = $(this);
    initFeaturedSeriesCarousel(elm);
  });

  $(".tema-tabs--mobile .vtab-toggle").on("click", function () {
    const elm = $(this);
    const elmTarget = elm.data("target");

    // check if there are featured series slider in tabs
    // if have, reinit the slider
    const sliderInTab = $(elmTarget).find(
      ".featured-series-carousel.slick-initialized"
    );
    if (sliderInTab.length > 0) {
      sliderInTab.slick("unslick");
      initFeaturedSeriesCarousel(sliderInTab);
    }
  });

  $(".idea-timeline").each(function (index) {
    const elm = $(this);
    const compact = $(this).data('compact');

    elm.slick({
      infinite: false,
      slidesToShow: compact === 1 ? 6 : 4,
      slidesToScroll: compact === 1 ? 6 : 4,
      autoplay: false,
      arrows: true,
      prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
      nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: compact === 1 ? 4 : 3,
            slidesToScroll: compact === 1 ? 4 : 3,
          },
        },
        {
          breakpoint: 640,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
      ],
    });
  });

  $(".gallery-slides").each(function (index) {
    const elm = $(this);
    const dots = elm.data("dots") ?? true;

    elm.slick({
      autoplay: false,
      autoplaySpeed: 500,
      slidesToShow: 1,
      arrows: true,
      dots: dots,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            dots: true,
          },
        },
      ],
    });
  });

  $(".highlights-slider").each(function (index) {
    const elm = $(this);

    elm.slick({
      infinite: false,
      rows: 2,
      slidesPerRow: 1,
      autoplay: false,
      arrows: true,
      prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
      nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            rows: 1,
          },
        },
      ],
    });
  });

  $(".highlights-slider").each(function (index) {
    const elm = $(this);

    elm.slick({
      infinite: false,
      rows: 2,
      slidesPerRow: 1,
      autoplay: false,
      arrows: true,
      prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
      nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            rows: 1,
          },
        },
      ],
    });
  });

  // Cards slider for narrow body content layout
  $(".compact-cards-slider").each(function (index) {
    const elm = $(this);

    elm.slick({
      infinite: false,
      slidesToShow: 3,
      autoplay: false,
      arrows: true,
      prevArrow: elm.siblings(".pagination").children(".btn-pager-prev"),
      nextArrow: elm.siblings(".pagination").children(".btn-pager-next"),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  // Slick carousels ////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // vCollapse //////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////

  $(".vcollapse-default").each(function (index) {
    $(this).vCollapse({
      onLoad: "none",
      any: true,
      speed: 300,
    });
  });

  $(".collapse-any-expand-first").each(function (index) {
    $(this).vCollapse({
      any: true,
      speed: 300,
    });
  });

  $(".collapse-one-expand-first").each(function (index) {
    $(this).vCollapse({
      any: false,
      speed: 300,
    });
  });
  // vCollapse //////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // vTabs //////////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".tema-tabs--hover").each(function (index) {
    const elm = $(this);
    const settings = {
      hover: true,
    };

    elm.vTabs(settings);
  });

  $(".tema-tabs--mobile").each(function (index) {
    const elm = $(this);

    elm.vTabs({
      mobileOnly: true,
    });
  });

  $(".tema-tabs--default").each(function (index) {
    const elm = $(this);
    const hover = elm.data("hover") ?? false;
    const mobileOnly = elm.data("mobileOnly") ?? false;
    const variableHeight = elm.data("variableHeight") ?? true;
    const mobileViewportWidth = elm.data("mobileViewportWidth") ?? 639;

    elm.vTabs({
      hover: hover,
      mobileOnly: mobileOnly,
      variableHeight: variableHeight,
      mobileViewportWidth: mobileViewportWidth,
    });
  });
  // vTabs //////////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Toggle mobile filters # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $("button.mobile-filter-toggle").on("click", function () {
    $(".mobile-filters").removeClass("active");
    $("body").addClass("overflow-hidden");
    $(this).next(".mobile-filters").addClass("active");
  });
  $("button.close-mobile-filter").on("click", function () {
    $(".mobile-filters").removeClass("active");
    $("body").removeClass("overflow-hidden");
  });
  // Toggle mobile filters # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  $(".download-count").on("click", function (e) {
    const id = $(this).data("id");

    if (id === undefined) {
      return;
    }

    const data = { id };

    const settings = {
      url: "/api/publication/download/count",
      data: JSON.stringify(data),
      method: "POST",
      timeout: 0,
      headers: {
        "Content-Type": "application/json",
      },
      error: function (error) {
        console.log("error", error);
      },
    };

    $.ajax(settings).done(function (response) {
      // console.log('response', response);
      $(".download-count-value").html(response);
    });
  });

  // Modals # ///////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////

  // define function under global scope so it is accesible for React created elements
  let downloadUrl = '';
  let modalId = '';
  const pubId = $('#downloadLink').data('id');
  let submissionCheck = null;

  window.openModal = function () {
    // listen for dynamically added elements
    $(document).on("click", ".button-open-modal", function (e) {
      submissionCheck = window.localStorage.getItem("idea_pub_predownload_form_" + pubId);

      if (submissionCheck === 'submiited') { 
        return; 
      }

      const target = $($(this).data("target"));
      modalId = $(this).data("target");

      if (target.attr('id') === 'publication-download-modal') {
        downloadUrl = $('#downloadLink').attr('href');
      }

      if (target.length > 0) {
        $("#overlay-mask").fadeIn();
        target.delay(500).fadeIn();
      }

      e.preventDefault();
    });
  };

  window.openModal();

  $('a.btn.button-send-feedback.button-open-modal.pointer-events-none').removeClass('pointer-events-none');

  $(".button-close-modal").on("click", function (e) {
    const target = $($(this).data("target"));

    target.fadeOut();
    $("#overlay-mask").delay(500).fadeOut();
  });

  // close modal when outer wrapper is clicked
  $(".modal-wrapper").on("click", function (e) {
    e.preventDefault();
    const target = $(this);

    target.fadeOut();
    $("#overlay-mask").delay(500).fadeOut();
    $("body").removeClass("overflow-hidden");
  });

  $(".modal-content").on("click", function (e) {
    e.stopPropagation();
  });
  // Modals # ///////////////////////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  $(".button-close-floating-feedback").on("click", function () {
    const target = $($(this).data("target"));

    target.fadeOut();
  });

  var colors = [
    "#F38336",
    "#004587",
    "#5DB3B2",
    "#E8346A",
    "#36A0E7",
    "#004587",
    "#665EA6",
  ];
  $(".hashtag").each(function () {
    var randomIndex = Math.floor(Math.random() * colors.length);
    $(this).css("color", colors[randomIndex]);
  });

  // Ticker ////////////////////////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  function initTicker(elm) {
    let item = elm.data("item");
    let pauseOnHover = elm.data("pauseonhover");

    if (item === undefined) {
      item = "div";
    }
    if (pauseOnHover === undefined) {
      pauseOnHover = false;
    }

    elm.ticker({
      item,
      pauseOnHover,
    });
  }

  let windowResize = null;

  $(".tema-ticker").each(function (index) {
    const elm = $(this);
    const breakpoint = elm.data("breakpoint");

    if (elm.css("display") === "none") {
      windowResize = function () {
        const ww = $(window).width();

        if (!elm.hasClass(".js-ticker") && ww >= breakpoint) {
          $(window).off("resize", windowResize);
          initTicker(elm);
        }
      };

      $(window).on("resize", windowResize);

      return;
    }

    initTicker(elm);
  });
  // Ticker ////////////////////////////////////////////////////////////////////////
  // /////////////////////////////////////////////////////////////////////////////// END

  // Sticky anchor block links # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  const anchorBlocks = $(".anchor-block");
  if (anchorBlocks.length > 0) {
    const anchorNavigation = $(".anchor-navigation");

    anchorBlocks.each(function () {
      let id = $(this).attr("id");
      let label = $(this).data("label");

      if (id && label) {
        let anchorLink = $("<a class='anchor-link'>")
          .attr("href", "#" + id)
          .text(label);

        // append the anchor tag to the placeholder div
        anchorNavigation.find(".container").append(anchorLink);
      }
    });

    $(window).on("scroll", function () {
      let currentBlock;
      anchorBlocks.each(function () {
        const blockOffset =
          $(this).offset().top - parseInt($(this).css("margin-top")) / 2;
        const windowTop =
          $(window).scrollTop() + anchorNavigation.outerHeight() + 16;
        if (windowTop >= blockOffset) {
          currentBlock = this;
        }
      });

      const stickyCheckBlockOffset =
        anchorBlocks.first().offset().top -
        parseInt(anchorBlocks.first().css("margin-top")) / 2;
      const stickyCheckWindowTop =
        $(window).scrollTop() + anchorNavigation.outerHeight() + 16;

      if (stickyCheckWindowTop >= stickyCheckBlockOffset) {
        anchorNavigation.addClass("sticky-anchor-nav shadowify");
      } else {
        anchorNavigation.removeClass("sticky-anchor-nav shadowify");
        anchorNavigation.find(".anchor-link").removeClass("active");
      }

      if (currentBlock) {
        const id = $(currentBlock).attr("id");
        const anchorLink = $('a[href="#' + id + '"]');
        if (!anchorLink.hasClass("active")) {
          anchorLink.addClass("active").siblings().removeClass("active");
        }
      }
    });
  }
  // Sticky anchor block links # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $('a[href*="#"]:not([href="#"]):not(.sf-dump-toggle)').on(
    "click",
    function () {
      let margin = 0;
      if ($(this).hasClass("anchor-link")) {
        margin = $(".anchor-navigation").outerHeight();
      }

      if (
        location.pathname.replace(/^\//, "") ==
        this.pathname.replace(/^\//, "") &&
        location.hostname == this.hostname
      ) {
        var target = $(this.hash);
        target = target.length
          ? target
          : $("[name=" + this.hash.slice(1) + "]");
        if (target.length) {
          $("html,body").animate(
            {
              scrollTop: target.offset().top - margin,
            },
            1000
          );

          target.trigger("focus");
          return false;
        }
      }
    }
  );
  // Smooth scrolling to anchor # ///////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Unhide preloaded content # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".tema-load-more").on("click", function () {
    const elm = $(this);
    const group = elm.data("group");
    let groupElms = $("." + group);

    groupElms.each(function () {
      if ($(this).css("display") === "none") {
        $(this).fadeIn();
        return false;
      }
    });

    elm.hide();

    groupElms.each(function () {
      if ($(this).css("display") === "none") {
        elm.show();
      }
    });
  });
  // Unhide preloaded content # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Play youtube iframe on trigger # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".custom-youtube-player").each(function () {
    const elm = $(this);
    const videoId = elm.data("youtube-id");
    elm.addClass("video-block my-4");
    elm.prepend(
      `<div class="video-block__placeholder">
      <iframe src="https://www.youtube.com/embed/${videoId}?enablejsapi=1"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>`
    );

    if (elm.data("thumbnail-play-button") === true) {
      elm
        .find("img[data-thumbnail=true]")
        .wrap(
          '<div class="bg-white video-block__play thumbnail-play-button"></div>'
        );
    } else if (elm.data("has-thumbnail") === true) {
      elm.find("img[data-thumbnail=true]").addClass("video-block__thumbnail");
      elm.append(
        `<button role="button" type="button" class="video-block__play"></button>`
      );
    } else {
      elm.append(
        `<img class="video-block__thumbnail" src="https://img.youtube.com/vi/${videoId}/hqdefault.jpg" alt="" />`
      );
      elm.append(
        `<button role="button" type="button" class="video-block__play"></button>`
      );
    }

    elm.find(".placeholder-text").remove();
  });

  $(".video-block__play").on("click", function () {
    // console.log("play video..");
    const trigger = $(this);
    const videoPlayer = trigger
      .parents(".video-block")
      .find(".video-block__placeholder iframe");

    videoPlayer[0].contentWindow.postMessage(
      '{"event":"command","func":"playVideo","args":""}',
      "*"
    );

    setTimeout(function () {
      trigger.fadeOut();
      trigger.siblings(".video-block__thumbnail").fadeOut();
    }, 300);
  });

  // Play youtube iframe on trigger # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  $(".vselect").each(function () {
    const s = $(this);
    let settings = {};

    if (s.data("multi-select") !== undefined) {
      settings.multiSelect = s.data("multi-select");
    }
    if (s.data("search") !== undefined) {
      settings.search = s.data("search");
    }
    if (s.data("placeholder") !== undefined) {
      settings.placeholder = s.data("placeholder");
    }
    if (s.data("display") !== undefined) {
      settings.display = s.data("display");
    }

    settings.onChange = function (values, options) {
      // console.log("values", values);

      if (s.data("action") === "redirect") {
        window.location = values.value;
      }
    };

    settings.searchPosition = -1;

    s.vSelect(settings);
  });

  // Collapsible sidebar nav # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".sidebar-nav ul li.menu-item--expanded > a").append(
    "<span class='toggle-children'></span>"
  );
  $(".sidebar-nav a.is-active").each(function () {
    $(this).parents(".menu").show();
    $(this).parents(".menu").prev().addClass("menu-children--expanded");
  });
  $(".sidebar-nav ul ul li a").each(function () {
    const elm = $(this);
    const href = elm.attr("href");
    const parentLink = elm.closest(".menu").siblings("a");
    const parentLinkHref = parentLink.attr("href");
    const currentUrl = window.location.pathname + window.location.hash;

    // if child link is anchor link of parent page, remove active class
    if (href.startsWith(parentLinkHref) && href !== currentUrl) {
      elm.removeClass("is-active");
    }
  });

  $(".sidebar-nav ul li a").on("click", function (e) {
    const elm = $(this);
    const href = elm.attr("href");
    if (href === "" || href === "#") {
      e.preventDefault();
    }
  });

  $(".sidebar-nav ul li.menu-item--expanded a .toggle-children").on(
    "click",
    function (e) {
      e.preventDefault();

      const elm = $(this);
      const elmParent = elm.parent();
      const href = elmParent.attr("href");

      if (href === "" || href === "#") {
        e.preventDefault();
      }

      if (elmParent.hasClass("menu-children--expanded")) {
        elmParent.removeClass("menu-children--expanded");
        elmParent.next().hide();
      } else {
        elmParent.addClass("menu-children--expanded");
        elmParent.next().show();
      }
    }
  );
  // Collapsible sidebar nav # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Search on glossary table # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  const glossaryLookup = $("#glossaryLookup");
  glossaryLookup.on("keyup", function () {
    var value = glossaryLookup.val().toLowerCase();
    $("#database-glossary-container table tr").filter(function () {
      $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
    });
  });
  // Search on glossary table # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Table Width # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  window.equaliseTableCellsWidth = function () {
    const tables = $(".table-width");

    tables.each(function () {
      let colW = 250;

      const table = $(this);

      if (table.hasClass('compact')) {
        colW = 150;
      }

      const referenceRow = table.find("thead tr.tw-ref-row");
      const numColumns =
        referenceRow.length > 0
          ? referenceRow.find("th").length
          : table.find("thead th").length;
      const cellWidth =
        referenceRow.length > 0 && referenceRow.data("cellwidth")
          ? referenceRow.data("cellwidth")
          : colW;

      const tableWidth = numColumns * cellWidth; // Assuming each column should have a width of 200px
      table.css("width", tableWidth + "px");

      if (referenceRow.length > 0) {
        table
          .find("thead tr.tw-ref-row")
          .first()
          .find("td, th")
          .css("width", cellWidth + "px");
      } else {
        table
          .find("thead tr")
          .first()
          .find("td, th")
          .css("width", cellWidth + "px");
      }
      table
        .find("tbody tr")
        .first()
        .find("td, th")
        .css("width", cellWidth + "px");
    });
  };
  window.equaliseTableCellsWidth();
  // Table Width # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Work modalities animation # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  const workModalities = $(".work-wrapper");
  $(window).on("scroll", function () {
    if (workModalities.isInViewport()) {
      setTimeout(function () {
        workModalities.addClass("animated");
      }, 500);
    } else {
      workModalities.removeClass("animated");
    }
  });
  // Work modalities animation # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  // Results management levels # /////////////////////////////////////////////////////
  // ////////////////////////////////////////////////////////////////////////////////
  $(".management-level-circles .circle-trigger").on("click", function () {
    const elm = $(this);
    const circleTarget = elm.data("target");
    $(
      ".management-level-circles .circle-trigger, .management-level-circles .circle-content"
    ).removeClass("active");
    // elm.addClass("active");
    $(`[data-target="${circleTarget}"]`).addClass("active");
    $(circleTarget).addClass("active");
  });
  // Results management levels # /////////////////////////////////////////////////////
  // //////////////////////////////////////////////////////////////////////////// END

  $('#mc-embedded-subscribe-form').on('submit', function () {
    // console.log('Form submitted');

    // Create a function to observe changes in the display property of #mce-success-response
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const successResponseElement = $('#mce-success-response');

        if (successResponseElement.css('display') === 'block' && successResponseElement.text().trim() === 'Thank you for subscribing!') {
          successResponseElement.text('Thank you for registering');

          setLocalStorageItem("idea_pub_predownload_form_" + pubId, "submiited");

          if (downloadUrl) {
            setTimeout(function () {
              $(modalId).fadeOut();
              $("#overlay-mask").delay(500).fadeOut();
              window.open(downloadUrl, '_blank');
            }, 1500);
          }
        }
      });
    });

    observer.observe(document.getElementById('mce-success-response'), {
      attributes: true,
      attributeFilter: ['style']
    });

  });



});
// Document.ready END
///////////////////////////////////////////////////////////////////////////////
